// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getMessaging, isSupported  } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyCYi-d1hZvAClOequdFR1OO4fcQ68DIuKw",
  authDomain: "coreventum-f2c9a.firebaseapp.com",
  projectId: "coreventum-f2c9a",
  storageBucket: "coreventum-f2c9a.firebasestorage.app",
  messagingSenderId: "455250950750",
  appId: "1:455250950750:web:ecaab25f9c8cdffe6ad2cf",
  measurementId: "G-TZFXKZ0RHR"
};

const app = initializeApp(firebaseConfig);

let messaging = null;

async function initMessaging() {
  console.log("Checking if Firebase Messaging is supported...");
  if (typeof window !== "undefined") {
    messaging = getMessaging(app);
    console.log("Firebase Messaging initializedhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhh.");
  } else {
    console.log("Firebase Messaging is not supported in this environment.");
  }
}
initMessaging();
export { app, messaging };

